import { runsOnDevice } from "../api/client.js";

/** Register the app-shell service worker in production (HTTPS). */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;
  // Inside the APK the app is served from the package itself, so an offline
  // cache buys nothing — and its cache survives app updates (reinstalling keeps
  // app data), so it would keep serving the PREVIOUS version's interface after
  // an update. Remove any worker an earlier build registered, clear what it
  // cached, and never register one. The PWA is unaffected.
  if (runsOnDevice()) {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => undefined);
    if ("caches" in window) {
      void caches
        .keys()
        .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
        .catch(() => undefined);
    }
    return;
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error: unknown) => {
      console.warn("Service worker registration failed:", error);
    });
  });
}
